<template>
	<div class="setting">
		<!-- 主页内容 -->
		<div class="main">
			<div class="content">
				<el-tabs v-model="activeName">
					<el-tab-pane class="content-pane" label="访员管理" name="first">
						<div class="head">
							<el-input class="search-input" clearable size="mini" placeholder="搜索访员" v-model="search_input">
								<el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
							</el-input>
							<div class="fr">
								<el-button size="mini" type="primary" @click="dialogFileFormVisible = true">批量导入</el-button>
								<el-button size="mini" type="success" @click="dialogAddFormVisible = true">手动添加</el-button>

								<el-popconfirm title="确定删除吗？" @confirm="handleDelete">
									<el-button style="margin-left: 10px;" slot="reference" size="mini" type="danger" :disabled="selectedTableData.length == 0">删除</el-button>
								</el-popconfirm>
								<!-- <el-button size="mini" type="danger" @click="handleDelete" >删除</el-button> -->
							</div>
						</div>
						<div class="table-wrapper">
							<el-table
								class="table"
								ref="multipleTable"
								:data="tableData"
								tooltip-effect="dark"
								style="width: 100%"
								size="small"
								border
								stripe
								@selection-change="handleSelectionChange"
							>
								<!-- 姓名，性别，年龄，学历，手机，邮箱，身份证，地址，类型 -->
								<el-table-column type="selection" width="50" align="center"></el-table-column>
								<el-table-column prop="loginname" label="账号" width="120" align="center"></el-table-column>
								<el-table-column prop="username" label="姓名" width="120" align="center"></el-table-column>
								<el-table-column prop="sex" label="性别" width="50" align="center">
									<template slot-scope="scope">
										<template v-if="scope.row.sex == 1">
											男
										</template>
										<template v-else-if="scope.row.sex == 2">
											女
										</template>
										<template v-else>
											未知
										</template>
									</template>
								</el-table-column>
								<el-table-column prop="age" label="年龄" width="50" align="center"></el-table-column>
								<el-table-column prop="education" label="学历" width="60" align="center"></el-table-column>
								<el-table-column prop="contactNumber" label="手机" width="120" align="center"></el-table-column>
								<el-table-column prop="email" label="邮箱" width="120" align="center"></el-table-column>
								<el-table-column prop="idNumber" label="身份证" align="center"></el-table-column>
								<el-table-column prop="address" label="地址" width="120" align="center" show-overflow-tooltip>
									<template slot-scope="scope">
										{{ `${scope.row.province} ${scope.row.city} ${scope.row.county} ${scope.row.address}` }}
									</template>
								</el-table-column>
								<el-table-column prop="type" label="操作" align="center">
									<template slot-scope="scope">
										<el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>

										<el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.$index, scope.row)">
											<el-button slot="reference" size="mini" type="danger">删除</el-button>
										</el-popconfirm>
										<el-button size="mini" type="primary" @click="handlePass(scope.$index, scope.row)">修改密码</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="page-wrapper">
							<el-pagination
								class="page"
								background
								layout="prev, pager, next"
								:current-page="page.pageIndex"
								:total="page.total"
								@current-change="handlePageChange"
							></el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<!-- 手动添加 -->
		<el-dialog title="添加访员" :close-on-click-modal="!1" :close-on-press-escape="!1" :visible.sync="dialogAddFormVisible" append-to-body >
			<el-form label-position="right" label-width="80px" :model="add_form" :rules="rules" ref="add_form">
				<el-row>
					<el-col :span="12">
						<el-form-item label="账号" prop="loginname"><el-input v-model="add_form.loginname" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="密码" prop="userppwd"><el-input v-model="add_form.userppwd" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="姓名" prop="username"><el-input v-model="add_form.username" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="年龄"><el-input v-model="add_form.age" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="性别">
							<el-radio-group v-model="edit_form.sex">
								<el-radio label="3">未知</el-radio>
								<el-radio label="1">男</el-radio>
								<el-radio label="2">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="学历"><el-input v-model="add_form.education" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号"><el-input v-model="add_form.contactNumber" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="邮箱"><el-input v-model="add_form.email" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="身份证号"><el-input v-model="add_form.idNumber" autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="地址">
							<el-cascader v-model="region" :options="city"></el-cascader>
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="add_form.address"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogAddFormVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="handleAddInterviewerPeople">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 修改 -->
		<el-dialog title="修改访员" :close-on-click-modal="!1" :close-on-press-escape="!1" :visible.sync="dialogEditFormVisible" append-to-body>
			<el-form label-position="right" label-width="80px" :model="edit_form" :rules="rules" ref="edit_form">
				<el-row>
					<el-col :span="12">
						<el-form-item label="姓名" prop="username"><el-input v-model="edit_form.username" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="年龄"><el-input v-model="edit_form.age" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="性别">
							<el-radio-group v-model="edit_form.sex">
								<el-radio label="3">未知</el-radio>
								<el-radio label="1">男</el-radio>
								<el-radio label="2">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="学历"><el-input v-model="edit_form.education" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号"><el-input v-model="edit_form.contactNumber" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="邮箱"><el-input v-model="edit_form.email" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="身份证号"><el-input v-model="edit_form.idNumber" autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="地址">
							<el-cascader v-model="edit_region" :options="city"></el-cascader>
							<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="edit_form.address"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogEditFormVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="updateInterviewerUser">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 修改密码 -->
		<el-dialog title="修改密码" :close-on-click-modal="!1" :close-on-press-escape="!1" :visible.sync="dialogPassFormVisible" append-to-body>
			<el-form label-position="right" label-width="80px" :model="pass_form">
				<el-row>
					<el-col :span="12">
						<el-form-item label="姓名">{{ pass_form.username }}</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="密码"><el-input placeholder="请输入密码" v-model="pass_form.newPassword"></el-input></el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogPassFormVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="updatePassword">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 批量导入 -->
		<el-dialog title="批量导入" :close-on-click-modal="!1" :close-on-press-escape="!1" :visible.sync="dialogFileFormVisible" append-to-body>
			<el-row>
				<el-col :span="24">
					<a href="/InterviewerUser.xls" target="_blank"><el-button type="primary">模板下载</el-button></a>
				</el-col>
				<el-col :span="24" style="margin:15px 0;color:#F56C6C;">
					<span>提示：</span>
					<p style="text-indent:2em;">
						登录账号、手机号、邮箱数据不能和系统已有用户重复。如有重复数据请根据提示进行修改。为了能准确读取数据，地址填写必须完整 例如：山东省 济南市 槐荫区
					</p>
				</el-col>
				<el-col :span="24"><el-input type="file" v-model="fileName" @change.native="handleFileChange"></el-input></el-col>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogFileFormVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="AddInterviewerUserByFile">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import city from '@/data/city.json';

//初始化表单数据
function initFormData() {
	return {
		loginname: '',
		username: '',
		age: '',
		education: '',
		contactNumber: '', //手机号
		email: '',
		province: '',
		city: '',
		county: '', //县区
		address: '',
		idNumber: '',
		sex: '3',
		userppwd: ''
	};
}

export default {
	data() {
		return {
			rules: {
				loginname: [{ required: true, message: '请输入账户', trigger: 'blur' }],
				userppwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				username: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},
			activeName: 'first',
			value: '',
			options: [
				{
					label: '电访',
					value: '电访'
				},
				{
					label: '面访',
					value: '面访'
				}
			],
			search_input: '',
			tableData: [],
			selectedTableData: [],
			dialogAddFormVisible: false,
			dialogEditFormVisible: false,
			dialogPassFormVisible: false,
			dialogFileFormVisible: false,
			fileName: '',
			fileData: null,
			add_form: initFormData(),
			edit_form: {},
			pass_form: {},
			city: city,
			page: {
				pageCount: 1,
				pageIndex: 1,
				pageSize: 10,
				total: 1
			}
		};
	},
	computed: {
		edit_region: {
			get() {
				let { province, city, county } = this.edit_form;
				return [province, city, county];
			},
			set(value) {
				console.log(value);
				let [province, city, county] = value;
				this.edit_form = Object.assign({}, this.edit_form, {
					province,
					city,
					county
				});
			}
		},
		region: {
			get() {
				let { province, city, county } = this.add_form;
				return [province, city, county];
			},
			set(value) {
				console.log(value);
				let [province, city, county] = value;
				this.add_form = Object.assign({}, this.add_form, {
					province,
					city,
					county
				});
			}
		}
	},
	mounted() {
		this.loadInterviewerUserDatas();
	},
	methods: {
		handleSelectionChange(e) {
			console.log('handleSelectionChange', e);
			this.selectedTableData = [...e];
		},
		handleAddInterviewerPeople() {
			if (this.add_form.loginname == '') {
				this.$message({
					message: '请输入账户',
					type: 'warn'
				});
				return false;
			}
			if (this.add_form.userppwd == '') {
				this.$message({
					message: '请输入密码',
					type: 'warn'
				});
				return false;
			}
			if (this.add_form.username == '') {
				this.$message({
					message: '请输入姓名',
					type: 'warn'
				});
				return false;
			}
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

			this.$api
				.AddInterviewerUser(this.add_form)
				.then(data => {
					this.$message({
						message: data.message,
						type: 'success'
					});
					this.dialogAddFormVisible =false
					this.add_form  = {
						loginname: '',
						username: '',
						age: '',
						education: '',
						contactNumber: '', //手机号
						email: '',
						province: '',
						city: '',
						county: '', //县区
						address: '',
						idNumber: '',
						sex: '3',
						userppwd: ''
					}
				})
				.catch(error => {
					this.$message({
						message: error.message,
						type: 'warn'
					});
				})
				.finally(() => {
					loading.close();
					this.loadInterviewerUserDatas();
				});
		},
		handlePageChange(page) {
			this.page.pageIndex = page;
			this.loadInterviewerUserDatas();
		},
		loadInterviewerUserDatas() {
			this.$api
				.InterviewerUserList(this.page.pageIndex, this.page.pageSize, this.search_input)
				.then(data => {
					this.tableData = data.resultBody.datas;
					let { pageCount, pageIndex, pageSize, total } = data.resultBody;
					this.page = Object.assign({}, this.page, {
						pageCount,
						pageIndex,
						pageSize,
						total
					});
				})
				.catch(error => {
					console.log(error);
					if (error.message == '暂无数据') {
						this.tableData = [];
						let { pageCount, pageIndex, pageSize, total } = error.resultBody;
						this.page = Object.assign({}, this.page, {
							pageCount,
							pageIndex,
							pageSize,
							total
						});
					}
				});
		},
		handleSearch() {
			this.loadInterviewerUserDatas();
		},
		handleEdit(index, item) {
			console.log('编辑', { index, item });
			this.edit_form = { ...item };
			this.edit_form.sex = [1, 2, '1', '2'].includes(this.edit_form.sex) ? this.edit_form.sex : '3';
			let { province, city, county } = this.edit_form;
			this.edit_region = [province, city, county];

			this.dialogEditFormVisible = true;
		},
		updateInterviewerUser() {
			if (this.edit_form.username == '') {
				this.$message({
					message: '请输入姓名',
					type: 'warn'
				});
				return false;
			}
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let data = JSON.parse(JSON.stringify(this.edit_form));
			this.$api
				.UpdateInterviewerUser(data)
				.then(data => {
					this.$message({
						message: data.message,
						type: 'success'
					});
					
				})
				.catch(error => {
					this.$message({
						message: error.message,
						type: 'warn'
					});
				})
				.finally(() => {
					loading.close();
					this.loadInterviewerUserDatas();
				});
				this.dialogEditFormVisible = false;
		},
		handleDelete(index, item) {
			let ids = [];
			if (typeof item == 'undefined') {
				console.log(this.selectedTableData);
				ids = this.selectedTableData.map(item => item.userId);
			} else {
				ids = [item.userId];
			}
			console.log('删除', { index, item });
			this.$api
				.DelInterviewerUser(ids)
				.then(data => {
					this.$message({
						message: data.message,
						type: 'success'
					});
				})
				.catch(error => {
					console.log(error);
				})
				.finally(() => {
					this.loadInterviewerUserDatas();
				});
		},
		handlePass(_index, item) {
			let { userId, username } = item;
			let newPassword = '';
			this.pass_form = { userId, username, newPassword };
			this.dialogPassFormVisible = true;
		},
		updatePassword() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$api
				.UpdatePassword(this.pass_form)
				.then(data => {
					this.$message({
						message: data.message,
						type: 'success'
					});
					this.dialogPassFormVisible = false;
				})
				.catch(error => {
					this.$message({
						message: error.message,
						type: 'warn'
					});
				})
				.finally(() => {
					loading.close();
				});
		},
		handleFileChange(e) {
			this.fileData = e.target.files[0];
		},
		AddInterviewerUserByFile() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$api
				.AddInterviewerUserByFile(this.fileData)
				.then(data => {
					this.$message({
						message: data.message,
						type: 'success'
					});
					this.loadInterviewerUserDatas();
					this.dialogFileFormVisible = false;
				})
				.catch(error => {
					this.$message({
						message: error.message,
						type: 'warn'
					});
				})
				.finally(() => {
					loading.close();
				});
		}
	}
};
</script>

<style lang="scss" scoped>
#app {
	background-color: #f5f5f5;
}
.fr {
	float: right;
}
.content-pane {
	min-height: 450px;
	position: relative;
	.head {
		margin-bottom: 10px;
	}
}
.table-wrapper {
	display: flex;
	justify-content: center;
	padding-bottom: 60px;
	.table {
		margin: 0 auto;
	}
}
.page-wrapper {
	display: flex;
	width: 100%;
	position: absolute;
	bottom: 0;
	.page {
		margin: 0 auto;
	}
}
.search-input {
	width: auto;
}
.setting {
	width: 100%;
	min-height: 100%;
	background: #f5f5f5;
	.content {
		min-height: 500px;
		background-color: #ffffff;
	}
}
</style>
